import { Tab } from "@renderbus/ui";
import styled from "styled-components";

export const TopUpSecondTabs = styled(Tab)<{ isForeign?: boolean }>`
  .ant-tabs-nav {
    z-index: 1;
  }
  .ant-tabs-content-holder {
    z-index: 2;
    background: #212327;
    box-shadow: 0px -5px 6.8px 0px #030b1363;
    padding: 16px;
    border-radius: 0 0 4px 4px;
  }

  .ant-tabs-nav-list {
    width: 100%;
    height: 42px;
    background: #181a1c;
    border-radius: 4px 4px 0 0;

    .ant-tabs-tab {
      justify-content: center;
      min-width: 240px;
      &.ant-tabs-tab-active {
        height: 42px;
        background: ${(p) =>
          p.isForeign
            ? "linear-gradient(104.4deg, #F3512B 2.85%, #EE9B52 100%)"
            : "linear-gradient(90deg, #2edb8a 0%, #13c5cb 100%)"};
        border-radius: 4px 4px 0 0;
      }
    }
    .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 0;
    }
  }
  &.ant-tabs.ant-tabs-top {
    .ant-tabs-nav {
      height: 42px !important;
      .ant-tabs-ink-bar[style] {
        &::after {
          display: none;
        }
      }
      .ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #ffffff !important;
      }
      .ant-tabs-tab {
        .ant-tabs-tab-btn {
          font-size: 16px !important;
          color: #f4f4f4 !important;
          font-weight: 600 !important;
        }

        :hover {
          &.ant-tabs-tab-active .ant-tabs-tab-btn {
            color: #f4f4f4 !important;
          }
          .ant-tabs-tab-btn {
            color: #13cb75 !important;
          }
        }
      }
    }
  }
`;
